export enum ImageFormat {
  SVG = 'svg',
  WEBP = 'webp',
  PNG = 'png',
  JPEG = 'jpeg',
  GIF = 'gif',
  OTHER = 'other',
}

type ImageAssetContentType =
  | 'image/jpeg'
  | 'image/png'
  | 'image/svg+xml'
  | 'image/webp'
  | 'image/gif'
  | string

export const getImageFormat = (contentType: ImageAssetContentType | undefined): ImageFormat => {
  switch (contentType) {
    case 'image/jpeg': {
      return ImageFormat.JPEG
    }
    case 'image/png': {
      return ImageFormat.PNG
    }
    case 'image/webp': {
      return ImageFormat.WEBP
    }
    case 'image/svg+xml': {
      return ImageFormat.SVG
    }
    case 'image/gif': {
      return ImageFormat.GIF
    }
    default: {
      return ImageFormat.OTHER
    }
  }
}

export const assetIsSvg = (contentType: ImageAssetContentType | undefined): boolean => {
  return getImageFormat(contentType) === ImageFormat.SVG
}
